import React from 'react';
import Slider from 'react-slick';

import 'slick-carousel/slick/slick.css';

export default function NextToRead(props) {
  const settings = {
    infinite: false,
    speed: 400,
    slidesToShow: 4,
    autoplay: false,
    arrows: false,
    dots: false,
    swipe: true,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          swipe: true,
        },
      },
    ],
    afterChange: function (a, b) {},
  };

  return (
    <div id="slider_reviews_2">
      <style jsx global>{`
        .slick-track {
          margin-left: 0;
          margin-right: 0;
        }
        .process-slider img {
          width: 242px;
          height: 242px;
          object-fit: cover;
        }
      `}</style>
      <Slider {...settings} className="process-slider relative z-10">
        {props.items?.map((item, ind) => {
          return (
            <a key={'item_' + ind} className={`w-full p-20 pl-0 `} href={'/blog/' + item.slug}>
              <img className="object-cover" width={242} height={242} src={process.env.NEXT_PUBLIC_IMAGE_PATH + item.photo} alt={item.post_title} />
              <p className="mt-[15px] font-[600] text-[16px]  leading-[29px] pr-[10px] w-[252px]">{item.post_title}</p>
            </a>
          );
        })}
      </Slider>
    </div>
  );
}
